import React from 'react'
import { Route, Switch } from 'react-router'
import ClipTrim from '../components/clip-trim'
import Upload from '../components/upload'
import Welcome from '../components/welcome'
import CreationToolStep from '../types/steps'
import { UPLOAD } from './index'

const UploadRoute = props => {
    return (
        <Switch>
            <Route
                exact
                path={`${UPLOAD}${CreationToolStep.route(CreationToolStep.Upload)}`}
                render={() => <Upload submitUrl={props.submitUrl} apiKey={props.apiKey} />}
            />
            <Route
                exact
                path={`${UPLOAD}${CreationToolStep.route(CreationToolStep.VideoTrim)}`}
                render={() => <ClipTrim />}
            />
            <Route exact path={UPLOAD} render={() => <Welcome />} />
        </Switch>
    )
}

export default UploadRoute
